export default "__VITE_ASSET__c72e460e__"